import { createSlice, current } from '@reduxjs/toolkit'
// eslint-disable-next-line import/no-cycle
import { getMarkers } from 'store'
import { PENDING, REJECTED, SUCCEEDED } from 'utils/constants'
import {
  getFriendMarkers,
  liveMarkerUpdate,
  staticMarkerUpdate,
  singleMarkerUpdate,
  getMarkerAvatars,
  updateMarkerAvatars,
  getEventMarkers,
  getEventData,
  getMarkersWithCW
} from './axios'

const initialState = {
  markers: [],
  friendMarkers: [],
  liveMarkerExp: null,
  staticMarkerExp: null,
  isUpdatingAvatar: false,
  northeast: [],
  southwest: [],
  isFiltered: false,
  filters: [],
  markerAvatars: [],
  storeId: '',
  isLocationMyPosition: false,
  openedMarkerCoordinate: null,
  currentChatFriendMarkerCoordinate: null,
  imageNaturalWidths: [],
  goToMinZoomOut: false,
  markerUpdate: true,
  eventMarkerUpdate: true,
  selectedMarkerData: null,
  mapStop: false,
  eventMarkers: [],
  eventData: null,
  eventId: null,
  isImageCarouselOpen: false,
  selectedEventData: null,
  singleMarkerUpdateItem: [],
  getMarkersStatus: PENDING | SUCCEEDED | REJECTED,
  getFriendMarkerStatus: PENDING | SUCCEEDED | REJECTED,
  getMarkerAvatarStatus: PENDING | SUCCEEDED | REJECTED,
  liveMarkerUpdateStatus: PENDING | SUCCEEDED | REJECTED,
  staticMarkerUpdateStatus: PENDING | SUCCEEDED | REJECTED,
  singleMarkerUpdateStatus: PENDING | SUCCEEDED | REJECTED,
  updateMarkerAvatarsStatus: PENDING | SUCCEEDED | REJECTED,
  getMarkersWithCWStatus: PENDING | SUCCEEDED | REJECTED,
  getEventMarkersStatus: PENDING | SUCCEEDED | REJECTED,
  getEventDataStatus: PENDING | SUCCEEDED | REJECTED
}

const markers = createSlice({
  name: 'markers',
  initialState,
  reducers: {
    handleLocationMyPosition: (state) => {
      state.isLocationMyPosition = !state.isLocationMyPosition
    },
    showCurrentChatFriendMarkerCoordinate: (state, { payload }) => {
      state.currentChatFriendMarkerCoordinate = payload
    },
    setGoToMinZoomOut: (state, { payload }) => {
      state.goToMinZoomOut = payload
    },
    // cannot be used due to bugs
    getIdfromParam: (state, { payload }) => {
      state.storeId = payload
    },
    clearId: (state) => {
      state.storeId = ''
    },
    setMarkerUpdate: (state, { payload }) => {
      state.markerUpdate = payload
    },
    setBounds: (state, { payload }) => {
      state.northeast = payload?.northeast
      state.southwest = payload?.southwest
    },
    xmppUpdateFriendLocation: (state, { payload }) => {
      const friendLocation = payload
      // from : "501167-0@dat01.turnkeywebstores.biz"
      // fromNickname : "Live location enabled"
      // geo: { "lat": 60.2029599, "lng": 24.6540796 }
      const friendId = Number(friendLocation.from.split('-')[0])
      const newLocation = [friendLocation.geo.lat, friendLocation.geo.lng]
      if (Number.isNaN(friendId)) {
        return
      }
      const date = new Date()
      const dateStr = date.toISOString().replace('T', ' ').slice(0, 19)
      state.markers.forEach((e) => {
        if (e.id === friendId) {
          e.coordinates = newLocation
          e.last_accessed = dateStr
          e.isLive = true
        }
      })
    },
    filterMarkers: (state, { payload }) => {
      state.filters = payload
      if (payload.affinities.length > 0
      || payload.codewords.length > 0) {
        state.isFiltered = true
      } else {
        state.isFiltered = false
      }
    },
    removeMarker: (state, action) => {
      console.log(action.payload)
      state.markers?.some((items, index) => {
        if (items?.id === action.payload) {
          console.log('remove')
          state.markers.splice(index, 1)
          return true
        }
        return false
      })
    },
    setSelectedMarkerData: (state, action) => {
      state.selectedMarkerData = action.payload
    },
    setIsUpdatingAvatar: (state, { payload }) => {
      state.isUpdatingAvatar = payload
    },
    stopMap: (state, { payload }) => {
      state.mapStop = payload
    },
    setSelectedEventData: (state, { payload }) => {
      state.selectedEventData = payload
    },
    setEventId: (state, { payload }) => {
      state.eventId = payload
    },
    setEventMarkerUpdate: (state, { payload }) => {
      state.markerUpdate = payload
    },
    clearEventMarkers: (state) => {
      state.eventMarkers = []
    },
    setEventData: (state, { payload = null }) => {
      state.eventData = payload
    },
    removeEventMarker: (state, action) => {
      state.eventMarkers?.some((items, index) => {
        if (items?.id === action.payload) {
          state.eventMarkers.splice(index, 1)
          return true
        }
        return false
      })
    },
    toggleImageCarousel: (state, action) => {
      state.isImageCarouselOpen = action.payload
    },
    addNaturalWidths: (state, action) => {
      state.imageNaturalWidths = action.payload
    }
  },
  extraReducers: {
    [getMarkers.pending]: (state) => {
      state.getMarkersStatus = PENDING
    },
    [getMarkers.fulfilled]: (state, action) => {
      state.getMarkersStatus = SUCCEEDED
      state.markers = action.payload?.data
      state.liveMarkerExp = action.payload?.liveMarkersExpiration
      state.staticMarkerExp = action.payload?.staticMarkersExpiration
    },
    [getMarkers.rejected]: (state) => {
      state.getMarkersStatus = REJECTED
    },
    // Get Friend Marker
    [getFriendMarkers.pending]: (state) => {
      state.getFriendMarkerStatus = PENDING
    },
    [getFriendMarkers.fulfilled]: (state, action) => {
      state.getFriendMarkerStatus = SUCCEEDED
      state.friendMarkers = action.payload
    },
    [getFriendMarkers.rejected]: (state) => {
      state.getFriendMarkerStatus = REJECTED
    },
    // Get Live Marker
    [liveMarkerUpdate.pending]: (state) => {
      state.liveMarkerUpdateStatus = PENDING
    },
    [liveMarkerUpdate.fulfilled]: (state, action) => {
      state.liveMarkerUpdateStatus = SUCCEEDED
      state.liveMarkerExp = action.payload?.expiration

      action.payload?.deletedProfiles.forEach((item) => {
        state.markers?.some((items, index) => {
          if (items?.id === item?.profile_id) {
            state.markers.splice(index, 1)
            return true
          }
          return false
        })
      })

      action.payload?.data.forEach((item) => {
        let found = false

        state.markers?.some((items) => {
          if (items?.id === item?.id) {
            items.coordinates = item?.coordinates
            found = true
            return true
          }
          return false
        })

        if (!found) {
          state.markers.push(item)
        }
      })
    },
    [liveMarkerUpdate.rejected]: (state) => {
      state.liveMarkerUpdateStatus = REJECTED
    },
    // Get Static Marker
    [staticMarkerUpdate.pending]: (state) => {
      state.staticMarkerUpdateStatus = PENDING
    },
    [staticMarkerUpdate.fulfilled]: (state, action) => {
      state.staticMarkerUpdateStatus = SUCCEEDED
      state.staticMarkerExp = action.payload?.expiration

      action.payload?.deletedProfiles.forEach((item) => {
        state.markers?.some((items, index) => {
          if (items?.id === item?.profile_id) {
            state.markers.splice(index, 1)
            return true
          }
          return false
        })
      })

      action.payload?.data.forEach((item) => {
        let found = false

        state.markers?.some((items) => {
          if (items?.id === item?.id) {
            items.coordinates = item?.coordinates
            found = true
            return true
          }
          return false
        })

        if (!found) {
          state.markers.push(item)
        }
      })
    },
    [staticMarkerUpdate.rejected]: (state) => {
      state.staticMarkerUpdateStatus = REJECTED
    },
    // Get Single Marker
    [singleMarkerUpdate.pending]: (state) => {
      state.singleMarkerUpdateStatus = PENDING
    },
    [singleMarkerUpdate.fulfilled]: (state, action) => {
      state.singleMarkerUpdateStatus = SUCCEEDED

      state.singleMarkerUpdateItem = action?.payload[0]

      let found = false
      state.markers?.some((items) => {
        if (items?.id === action?.payload[0]?.id) {
          items.coordinates = action?.payload[0]?.coordinates
          found = true
          return true
        }
        return false
      })

      if (!found) {
        state.markers.push(action?.payload[0])
      }
    },
    [singleMarkerUpdate.rejected]: (state) => {
      state.singleMarkerUpdateStatus = REJECTED
    },
    // Get Marker Avatars
    [getMarkerAvatars.pending]: (state) => {
      state.getMarkerAvatarStatus = PENDING
    },
    [getMarkerAvatars.fulfilled]: (state, action) => {
      state.getMarkerAvatarStatus = SUCCEEDED
      if (current(state.markerAvatars).some((e) => e.markerID === action.payload.markerID) === false
        && action.payload.markerID) {
        state.markerAvatars.push(action.payload)
      }
    },
    [getMarkerAvatars.rejected]: (state) => {
      state.getMarkerAvatarStatus = REJECTED
    },
    // Update Marker Avatars
    [updateMarkerAvatars.pending]: (state) => {
      state.updateMarkerAvatarsStatus = PENDING
    },
    [updateMarkerAvatars.fulfilled]: (state, action) => {
      state.updateMarkerAvatarsStatus = SUCCEEDED
      if (action.payload) {
        action.payload?.data.forEach((item) => {
          if (
            current(state.markerAvatars).some((e) => e.markerID === item.id) === false
              && item.id
          ) {
            state.markerAvatars.push({
              markerID: item?.id,
              imageBase64: item?.profile_picture
            })
          }
        })
      }
    },
    [updateMarkerAvatars.rejected]: (state) => {
      state.updateMarkerAvatarsStatus = REJECTED
    },
    // Get Event Markers
    [getEventMarkers.pending]: (state) => {
      state.getEventMarkersStatus = PENDING
    },
    [getEventMarkers.fulfilled]: (state, action) => {
      state.getEventMarkersStatus = SUCCEEDED
      state.eventMarkers = action.payload
    },
    [getEventMarkers.rejected]: (state) => {
      state.getEventMarkersStatus = REJECTED
    },
    // Get Event Data
    [getEventData.pending]: (state) => {
      state.getEventDataStatus = PENDING
      state.isImageCarouselOpen = false
    },
    [getEventData.fulfilled]: (state, action) => {
      state.getEventDataStatus = SUCCEEDED
      const eventData = action.payload
      state.eventData = eventData

      if (eventData?.id) {
        let found = false
        state.eventMarkers?.some((items) => {
          if (items?.id === eventData?.id) {
            items.coordinates = [eventData?.lat, eventData?.lng]
            items.end_date = eventData?.end_date

            found = true
          }
          return found
        })

        if (!found) {
          state.eventMarkers.push(eventData)
        }
      }
    },
    [getEventData.rejected]: (state) => {
      state.getEventDataStatus = REJECTED
    },
    // Get markers with a certain codeword
    [getMarkersWithCW.pending]: (state) => {
      state.getMarkersWithCWStatus = PENDING
    },
    [getMarkersWithCW.fulfilled]: (state, action) => {
      const markersWithCW = action.payload.data
      const searchedCW = action.meta.arg.title

      state.markers.map((item) => {
        if (markersWithCW.includes(item.id)) {
          if (Array.isArray(item.codewords) && !item.codewords.includes(searchedCW)) {
            item.codewords = [...item.codewords, action.meta.arg.title]
          } else if (!Array.isArray(item.codewords)) {
            item.codewords = [action.meta.arg.title]
          }
        }

        return item
      })

      state.getMarkersWithCWStatus = SUCCEEDED
    },
    [getMarkersWithCW.rejected]: (state) => {
      state.getMarkersWithCWStatus = REJECTED
    }
  }
})

export const {
  handleLocationMyPosition,
  showCurrentChatFriendMarkerCoordinate,
  setGoToMinZoomOut,
  getIdfromParam,
  clearId,
  setMarkerUpdate,
  setBounds,
  xmppUpdateFriendLocation,
  filterMarkers,
  removeMarker,
  setSelectedMarkerData,
  setIsUpdatingAvatar,
  stopMap,
  setSelectedEventData,
  setEventId,
  setEventMarkerUpdate,
  clearEventMarkers,
  setEventData,
  removeEventMarker,
  toggleImageCarousel,
  addNaturalWidths
} = markers.actions

export default markers.reducer
